module.exports = __webpack_public_path__ + "assets/img/text-optimization.b1515292.png";